import { Component, OnInit } from "@angular/core";
import { UserService } from "./shared/services/user.service";
import { cartAnimation } from "./shared/animations/cartAnimation";
import { SpinnerService } from "./shared/services/spinner.service";
import { LoaderService } from "./shared/services/loader-service";
import { CartService } from "./shared/services/cart-service";
import { trigger, transition, style, animate } from "@angular/animations";
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [cartAnimation],
})
export class AppComponent implements OnInit {
  title = "app-delivery";
  cart: boolean = false;
  constructor(
    public spinnerService: SpinnerService,
    public loader: LoaderService,
    public cartService: CartService
  ) {}

  ngOnInit() {
    this.spinnerService.show();
    this.cartService.getCartStatus().subscribe((cartOpen: boolean) => {
      this.cart = cartOpen;
    });
  }
}
